import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Zoom 
} from '@material-ui/core';

import logo from './../../assets/images/logos/m-clean.png';

const GeoLocDialog = (props) => {
 	return (
		<Dialog 
			open={props.dialogIsOpen} 
			onClose={props.handleDialogClose} 
			aria-labelledby="form-dialog-current-location" 
			fullWidth 
			maxWidth="sm"
			TransitionComponent={Zoom}
		>
			<DialogTitle 
				id="form-dialog-current-location" 
				className="dialog-title"
			>
				<img src={logo} className="mr-1" alt="Mulk.pk" />
				Oops, we cant find your location
			</DialogTitle>
			<DialogContent className="p-0">
				<div className="currentloc-permission-denied">
					<p>
						First, try refreshing the page and clicking Current Location again. Make sure you click <b>Allow</b> or <b>Grant Permissions</b> if your browser asks for your location. If your browser doesn't ask you, try these steps:
					</p>
				</div>
				<div className="chrome">
					<ol>
						<li>
							At the top of your Chrome window, near the web address, click <b>the green lock labeled Secure</b>.
						</li>
						<li>
							In the window that pops up, make sure <b>Location</b> is set to <b>Ask</b> or <b>Allow</b>.
						</li>
						<li>
							You're good to go! Reload this Mulk page and try your search again.
						</li>
					</ol>
				</div>
				<div className="google">
					<p>If you're still having trouble, check out <a href="https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=en&oco=0" rel="noreferrer" target="_blank">Google's support page</a>. You can also search near a city, place, or address instead.</p>
				</div>
			</DialogContent>
			<DialogActions className="dialog-footer">
				<Button onClick={props.handleDialogClose} color="primary">
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
  	)
}

export default GeoLocDialog;